import React from 'react';
import WrappedModal from 'components/modal/WrappedModal';
import { CustomerGroupFormFields } from './CustomerGroupFormFields';
import { useTranslation } from 'react-i18next';
import { Button, Form, Modal } from 'semantic';
import { Formik, FormikState } from 'formik';
import { CustomerGroup } from 'subdomains/cpo/screens/GroupsAndPolicies/types';
import { customerGroupSchema } from 'subdomains/cpo/screens/GroupsAndPolicies/validation';

type Props = {
  trigger: React.ReactNode;
  onSubmit: (newCustomerGroupId: string) => void;
  values?: FormikState<CustomerGroup>['values'];
};

export function CustomerGroupModal({ values, trigger, onSubmit }: Props) {
  const [isOpen, setIsOpen] = React.useState(true);

  const { t } = useTranslation();

  return (
    <WrappedModal isOpen={isOpen} setIsOpen={setIsOpen} trigger={trigger}>
      <Formik
        initialValues={values || ({ filters: [{}] } as CustomerGroup)}
        validationSchema={customerGroupSchema}
        onReset={() => setIsOpen(false)}
        onSubmit={(values: CustomerGroup) => {
          // TODO: do API request and return id and name of the group. Probably best to move that behaviour outside if this modal though.
          setIsOpen(false);
          onSubmit('');
        }}>
        {({ handleSubmit, handleReset, values }) => (
          <>
            <Modal.Header>
              {/* TODO: make conditional based on create vs update*/}
              {t('customerGroup.editCustomerGroupTitle', 'New Customer Group')}
            </Modal.Header>
            <Modal.Content>
              <Form>
                <CustomerGroupFormFields values={values} />
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button
                content={t(
                  'customerGroup.createButton',
                  'Create Customer Group'
                )}
                as="button"
                style={{ marginLeft: '0' }} // TODO: look for better solution
                onClick={handleSubmit}
              />
              <Button
                content={t('customerGroup.cancelButton', 'Cancel')}
                as="button"
                basic
                onClick={handleReset}
              />
            </Modal.Actions>
          </>
        )}
      </Formik>
    </WrappedModal>
  );
}
